import React, { Component } from 'react';

class IconPortfolio extends Component {
  render() {
    return (

      <div class="icon icon-portfolio">

      <svg viewBox="0 0 205 205" xmlns="http://www.w3.org/2000/svg" xmlnsSerif="http://www.serif.com/"
      fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
          <g id="icon-portfolio">
              <ellipse id="Oval-2" cx="102.378" cy="102.268" rx="102.378" ry="102.268"
              fill="#4a90e2" />
              <g id="Layer_1">
                  <path id="Shape" d="M164.739 55.139v98.613c0 2.799-2.336 5.133-5.138 5.133h-9.031V69.449l-23.979-23.953H64.307v-9.022c0-2.8 2.336-5.133 5.139-5.133h71.314v18.665c0 2.8 2.336 5.133 5.138 5.133h18.841z"
                  fill="#e6e9ee" />
                  <path id="Shape1" serifId="Shape" d="M140.916 31.341v18.665c0 2.8 2.335 5.133 5.138 5.133h18.685l-23.823-23.798z"
                  fill="#54c0eb" />
                  <path id="Shape2" serifId="Shape" d="M126.591 45.651H55.276c-2.802 0-5.138 2.333-5.138 5.133v117.277c0 2.8 2.336 5.133 5.138 5.133h89.999c2.803 0 5.139-2.333 5.139-5.133V69.449h-18.685c-2.803 0-5.138-2.333-5.138-5.133V45.651z"
                  fill="#fff" />
                  <path id="Shape3" serifId="Shape" d="M126.591 45.651v18.665c0 2.8 2.335 5.133 5.138 5.133h18.685l-23.823-23.798z"
                  fill="#84dbff" />
                  <path id="Shape4" serifId="Shape" d="M126.591 45.651v18.665c0 2.8 2.335 5.133 5.138 5.133h18.685l-23.823-23.798z"
                  fill="#fff" />
                  <path id="Shape5" serifId="Shape" d="M100.432 116.733c-.156 0-.156 0 0 0-.156 0-.156 0 0 0-9.81-4.822-8.72-10.888-8.72-10.888v-.311c2.336 2.955 5.45 4.822 8.72 4.822 3.269 0 6.228-1.867 8.719-4.822v.467c0 .933.156 6.377-8.719 10.732z"
                  fill="#f9b54c" />
                  <path id="Shape6" serifId="Shape" d="M100.432 116.733c-.156 0-.156 0 0 0-.156 0-.156 0 0 0z"
                  fill="#f1543f" />
                  <path id="Shape7" serifId="Shape" d="M100.276 146.286c13.079 0 24.757-6.222 32.231-15.865l-4.204-12.755-17.439-8.399c0 2.955-.156 8.244-1.09 14.776-2.18-6.843-9.498-7.31-9.498-7.31s-7.318.622-9.498 7.466c-.935-6.688-1.09-11.821-1.09-14.932l-17.44 8.399-4.204 12.755c7.474 9.643 19.152 15.865 32.232 15.865z"
                  fill="#324a5e" />
                  <g id="Group" fill="#fff">
                      <path id="Shape8" serifId="Shape" d="M108.996 105.845s1.089 6.222-8.72 10.888c0 0 7.318.622 9.498 7.466.156.156 4.048-14.776-.778-18.354z"
                      />
                      <path id="Shape9" serifId="Shape" d="M91.712 105.845s-1.09 6.222 8.72 10.888c0 0-7.319.622-9.499 7.466-.155.156-4.048-14.776.779-18.354z"
                      />
                  </g>
                  <path id="Shape10" serifId="Shape" d="M112.733 95.891c.311-1.711.467-3.578.467-5.133 0-9.333-5.762-13.066-12.924-13.066-7.163 0-12.924 3.733-12.924 13.066 0 1.711.156 3.422.467 5.133-1.09.466-1.401 2.177-.623 3.733.623 1.088 1.558 1.866 2.492 1.866 2.335 5.6 6.228 9.955 10.588 9.955 4.36 0 8.252-4.355 10.588-9.955.934 0 1.869-.778 2.491-1.866.779-1.556.467-3.111-.622-3.733z"
                  fill="#ffd05b" />
                  <path id="Shape11" serifId="Shape" d="M100.276 72.404s5.605.156 10.588 4.822c10.9 10.265-.623 25.508-.623 25.508s1.557-3.733.934-7.621c-.155-1.4-.311-2.955-.311-4.355.156-2.644-.467-6.688-6.851-5.6 0 0-3.581 2.645-12.301.467 0 0-5.606 8.555-2.491 15.865 0 0-9.187-13.843.467-22.709l-2.492.622s3.582-6.688 10.9-4.355c0 0-.623-1.089-2.958-1.711 0 0 3.269-1.4 5.138.934 0-.156 1.09-.934 0-1.867z"
                  fill="#324a5e" />
              </g>
          </g>
      </svg>

      </div>

    );
  }
}

export default IconPortfolio;



// WEBPACK FOOTER //
// ./src/assets/components/icons/iconPortfolio.js